import makeStyles from "@mui/styles/makeStyles";

export const tableStyles = makeStyles((theme) => ({
  tableTarget: {
    width: "27%",
  },

  tableDate: {
    width: "16%",
  },

  tableProtein: {
    width: "18%",
  },

  tableCarbs: {
    width: "18%",
  },

  tableFat: {
    width: "18%",
  },

  tableCalories: {
    width: "18%",
  },

  tableComments: {
    width: "20%",
  },

  tableAction: {
    width: "5%",
  },
}));
